import React from 'react'
import styles from './styles.module.css'

function ButtonOutline({ children, color, onClick }) {
  return (
    <button
      className={styles.button}
      style={{ color: color, border: `1px solid ${color}` }}
      onClick={onClick}>
      {children}
    </button>
  )
}

export default ButtonOutline